// ========================================
// Calificaciones Admin View — Gestión de Notas
// (Admin, Coordinador)
// ========================================

const CalificacionesAdminView = {
    _calificaciones: [],
    _selectedFormationId: null,
    _selectedPeriod: '1Trimestre', // '1Trimestre', '2Trimestre', 'Final'
    _selectedYear: null,
    _ready: false,
    _loading: false,
    _saving: false,
    _request: 0,
    canManage() { return ['admin','coordinator'].includes(AuthManager.getCurrentUser()?.role) || AuthManager.hasModule('calificaciones','manage'); },
    canRead() { return ['admin','coordinator','professor'].includes(AuthManager.getCurrentUser()?.role) || AuthManager.hasModule('calificaciones'); },
    currentYear() {
        const now = new Date(), start = now.getFullYear() - (now.getMonth() < 8 ? 1 : 0);
        return `${start}/${start+1}`;
    },

    PERIODS: [['1Trimestre', '1.er trimestre'], ['2Trimestre', '2.º trimestre'], ['Final', 'Final']],
    CRITERIA: [['tecnica', 'Técnica'], ['lenguaje', 'Lenguaje y estética'], ['compromiso', 'Compromiso'], ['colectivo', 'Colectivo'], ['adaptabilidad', 'Adaptabilidad']],
    SCORES: ['', 'APTO', 'AVISO', 'NO APTO'],
    _dirty: false,

    render() {
        if (!this.canRead()) return '<div role="alert" class="view-container">No tienes acceso a esta sección.</div>';
        this._selectedYear ||= this.currentYear();
        return `
        <div class="view-container dnr-proposal calif-view" style="padding-top: 1rem;">
            <style ${SafeHTML.styleAttr}>
                .calif-view { gap: 0.85rem; }
                .calif-view [hidden] { display: none !important; }
                .calif-top { display: flex; flex-wrap: wrap; align-items: center; gap: 0.6rem; }
                .calif-header-title { margin: 0 0.4rem 0 0; font-family: var(--dnr-display); font-weight: 400; font-size: 2.4rem; letter-spacing: 0.02em; line-height: 1; color: var(--dnr-ink); }
                .calif-select { min-height: 36px; border: 1px solid var(--dnr-line); border-radius: 10px; padding: 0 8px; background: var(--dnr-surface); color: var(--dnr-ink); font-weight: 700; font-family: inherit; }
                .calif-seg { display: inline-flex; gap: 3px; padding: 3px; background: var(--dnr-surface-sunken); border: 1px solid var(--dnr-line); border-radius: 11px; }
                .calif-seg button { min-height: 32px; padding: 0 12px; border: 0; border-radius: 8px; background: transparent; color: var(--dnr-ink-mute); font-weight: 700; font-size: 0.82rem; cursor: pointer; font-family: inherit; }
                .calif-seg button.is-on { background: var(--dnr-surface); color: var(--dnr-teal-900); box-shadow: 0 1px 3px rgba(0,0,0,.12); }
                .calif-seg button:disabled, .calif-select:disabled { cursor: default; opacity: 0.6; }
                .calif-spacer { flex: 1; }
                .calif-status { font-size: 0.8rem; font-weight: 700; padding: 5px 10px; border-radius: 999px; background: var(--dnr-surface-sunken); color: var(--dnr-ink-mute); }
                .calif-status.is-ok { background: var(--dnr-teal-100); color: var(--dnr-teal-700); }
                .calif-status.is-warn { background: var(--dnr-amber-100); color: #6B3A0B; }
                .calif-save { min-height: 40px; padding: 0 18px; border: 0; border-radius: 10px; background: var(--dnr-teal-600); color: #fff; font-weight: 700; font-size: 0.9rem; cursor: pointer; font-family: inherit; }
                .calif-save:disabled { opacity: 0.5; cursor: default; }
                .calif-readonly { font-size: 0.8rem; font-weight: 700; color: var(--dnr-ink-mute); }
                .calif-formation { min-width: 220px; max-width: 320px; }
                .calif-retry { margin-top: 1rem; min-height: 36px; padding: 0 14px; border: 1px solid var(--dnr-line); border-radius: 10px; background: var(--dnr-surface); color: var(--dnr-ink); font-weight: 700; cursor: pointer; font-family: inherit; }
                .calif-card { background: var(--dnr-surface); border: 1px solid var(--dnr-line); border-radius: 16px; box-shadow: var(--dnr-shadow-card); overflow: hidden; }
                .calif-card-head { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; padding: 0.75rem 1rem; border-bottom: 1px solid var(--dnr-line); }
                .calif-card-head > div { flex: 1; min-width: 240px; }
                .calif-card-head h2 { margin: 0; font-family: var(--dnr-display); font-weight: 400; font-size: 1.75rem; letter-spacing: 0.03em; line-height: 1; color: var(--dnr-ink); }
                .calif-card-head p { margin: 2px 0 0; font-size: 0.82rem; color: var(--dnr-ink-mute); }
                .calif-totals { display: inline-flex; flex-wrap: wrap; gap: 6px; font-size: 0.8rem; font-weight: 700; }
                .calif-totals span { padding: 3px 9px; border-radius: 999px; }
                .calif-table-wrap { max-height: 68vh; overflow: auto; }
                .calif-table { width: 100%; min-width: 1000px; border-collapse: collapse; font-size: 0.88rem; }
                .calif-table thead th { position: sticky; top: 0; z-index: 1; background: var(--dnr-surface-sunken); padding: 0.6rem 0.4rem; font: 700 0.66rem var(--dnr-mono); letter-spacing: 0.06em; text-transform: uppercase; color: var(--dnr-ink-mute); text-align: center; }
                .calif-table thead th:first-child, .calif-table thead th:last-child { text-align: left; padding-left: 1rem; }
                .calif-table thead th.is-final { background: var(--dnr-teal-100); color: var(--dnr-teal-700); }
                .calif-table tbody tr { border-top: 1px solid var(--dnr-line); }
                .calif-table tbody th { text-align: left; padding: 0.35rem 1rem; font-weight: 700; color: var(--dnr-ink); }
                .calif-table td { padding: 0.25rem; }
                .calif-cell { width: 100%; min-width: 92px; min-height: 34px; border-radius: 8px; cursor: pointer; font-weight: 700; font-size: 0.8rem; font-family: inherit; }
                .calif-cell:disabled { cursor: default; }
                .calif-cell.is-final { font-weight: 800; }
                .calif-notes-input { width: 100%; box-sizing: border-box; min-height: 34px; border: 1px solid var(--dnr-line); border-radius: 8px; padding: 0 10px; font-size: 0.82rem; font-family: inherit; background: var(--dnr-surface); color: var(--dnr-ink); }
                .calif-notes-input:focus { outline: none; border-color: var(--dnr-teal-500); box-shadow: 0 0 0 3px var(--dnr-teal-100); }
                .calif-empty { text-align: center; padding: 3.5rem 2rem; color: var(--dnr-ink-mute); }
                .calif-empty i { font-size: 2.4rem; margin-bottom: 1rem; opacity: 0.35; color: var(--dnr-teal-600); display: block; }
                .calif-empty h3 { font-family: var(--dnr-display); font-weight: 400; font-size: 1.4rem; letter-spacing: 0.02em; color: var(--dnr-ink); margin: 0 0 0.5rem 0; }
                .calif-empty p { margin: 0; font-size: 0.9rem; }
            </style>
            <header class="calif-top">
                <h1 class="calif-header-title">Calificaciones</h1>
                <select id="calif-year-select" class="calif-select" aria-label="Curso académico" ${UIEvents.attr('change', function(){CalificacionesAdminView.changeYear(this.value);})}></select>
                <select id="calif-type-select" class="calif-select" aria-label="Tipo de formación" ${UIEvents.attr("change", function(event,captured){CalificacionesAdminView.changeType(this.value);}, [])}></select>
                <select id="calif-formation-select" class="calif-select calif-formation" aria-label="Formación" ${UIEvents.attr("change", function(event,captured){CalificacionesAdminView.changeFormation(this.value);}, [])}></select>
                <div class="calif-seg" id="calif-period-select" role="tablist" aria-label="Periodo"></div>
                <span class="calif-spacer"></span>
                <span class="calif-status" id="calif-status" hidden></span>
                ${this.canManage() ? `<button type="button" id="calif-save-button" class="calif-save" disabled ${UIEvents.attr("click", function(event,captured){CalificacionesAdminView.saveCalificaciones();}, [])}>Publicar acta</button>` : '<span class="calif-readonly">Solo consulta</span>'}
            </header>
            <div id="calif-table-container" class="calif-card">
                ${this.renderEmptyState('fa-graduation-cap', 'Elige una formación', 'Elige una formación en el filtro de arriba para ver o poner sus notas.')}
            </div>
        </div>`;
    },

    renderEmptyState(icon, title, text) {
        return `
            <div class="calif-empty">
                <i class="fas ${icon}"></i>
                <h3>${Utils.sanitizeHTML(title)}</h3>
                <p>${text}</p>
            </div>`;
    },

    init() {
        if (!this.canRead()) return;
        this._ready = false;
        this._dirty = false;
        this._calificaciones = [];
        this.loadYears();
        this.loadFormations();
        this.renderPeriods();
        return this.loadCalificaciones();
    },
    renderPeriods() {
        const el = document.getElementById('calif-period-select');
        if (!el) return;
        SafeHTML.set(el, this.PERIODS.map(([id, label]) => `<button type="button" role="tab" class="${id === this._selectedPeriod ? 'is-on' : ''}" aria-selected="${id === this._selectedPeriod}"
            ${UIEvents.attr("click", function(event,captured){CalificacionesAdminView.changePeriod(String(captured[0]));}, [id])}>${label}</button>`).join(''));
    },
    // Avisa antes de cambiar de acta con notas sin publicar.
    _confirmLeave(go) {
        if (!this._dirty) return go();
        SafeHTML.fire({ title: 'Hay notas sin publicar', text: 'Si cambias de acta, se pierden los cambios.', icon: 'warning', showCancelButton: true,
            confirmButtonText: 'Cambiar sin publicar', cancelButtonText: 'Volver al acta', reverseButtons: true })
            .then(result => { if (result.isConfirmed) { this._dirty = false; go(); } else { this.loadYears(); this.loadFormations(); } });
    },
    destroy() { ++this._request; this._ready = false; this._calificaciones = []; },

    loadYears() {
        const select = document.getElementById('calif-year-select');
        if (!select) return;
        this._selectedYear ||= this.currentYear();
        // Curso actual + cursos anteriores en los que hubo clases + los que ya tienen actas
        // (antes se añadían siempre 5 años atrás y el siguiente, hubiera clases o no).
        const start = Number(this.currentYear().slice(0,4));
        const yearOf = value => { const d = new Date(value); return isNaN(d) ? null : (d.getMonth() >= 8 ? d.getFullYear() : d.getFullYear() - 1); };
        const classes = typeof DataManager !== 'undefined' ? (DataManager.getAll(DataManager.KEYS.CLASSES) || []) : [];
        const years = new Set([this.currentYear(), this._selectedYear, ...this._calificaciones.map(c=>c.year)]);
        // Courses with classes come from the server: the browser only holds the months on screen.
        for (const y of (typeof FileStorage !== 'undefined' && FileStorage.classYears) || []) if (y <= start) years.add(`${y}/${y+1}`);
        for (const cls of classes) { const y = yearOf(cls.startDate); if (y !== null && y <= start) years.add(`${y}/${y+1}`); }
        SafeHTML.set(select, [...years].filter(y=>/^\d{4}\/\d{4}$/.test(y)).sort().reverse().map(y=>`<option value="${y}">${y}</option>`).join(''));
        select.value = this._selectedYear;
    },

    changeYear(value) {
        if (this._saving || !/^\d{4}\/\d{4}$/.test(value)) return;
        this._confirmLeave(() => { this._selectedYear = value; this.renderTable(); });
    },

    updateControls() {
        const save = document.getElementById('calif-save-button');
        if (save) { save.disabled = !this.canManage() || !this._ready || this._saving || !this._selectedFormationId || !document.querySelector('#calif-table-container .calif-cell'); save.setAttribute('aria-busy',String(this._saving)); }
        document.querySelectorAll('#calif-year-select, #calif-type-select, #calif-formation-select, #calif-period-select button').forEach(el => { el.disabled = this._saving; });
        document.querySelectorAll('#calif-table-container .calif-cell, #calif-table-container input').forEach(el=>{el.disabled=!this.canManage() || this._saving;});
        this.renderStatus();
    },
    _acta() {
        return this._calificaciones.find(c => String(c.formationId) === String(this._selectedFormationId) && c.period === this._selectedPeriod && c.year === this._selectedYear) || null;
    },
    renderStatus() {
        const el = document.getElementById('calif-status');
        if (!el) return;
        const acta = this._ready && this._selectedFormationId ? this._acta() : null;
        el.hidden = !this._ready || !this._selectedFormationId;
        if (this._dirty) { el.className = 'calif-status is-warn'; el.textContent = 'Cambios sin publicar'; return; }
        const when = acta && (acta.updatedAt || acta.createdAt);
        el.className = `calif-status ${acta ? 'is-ok' : ''}`;
        el.textContent = acta ? (when ? `Publicada el ${new Date(when).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}` : 'Publicada') : 'Sin publicar';
    },
    _studentsOf(formationId) {
        const all = (typeof DataManager !== 'undefined' && DataManager.getAll) ? (DataManager.getAll(DataManager.KEYS.STUDENTS) || []) : [];
        return all.filter(s => s.formations && s.formations.map(String).includes(String(formationId)))
            .sort((a, b) => `${a.lastName || ''} ${a.firstName || ''}`.localeCompare(`${b.lastName || ''} ${b.firstName || ''}`, 'es'));
    },
    _selectedType: '',
    _formations() {
        return (typeof DataManager !== 'undefined' && DataManager.getFormations) ? DataManager.getFormations() : [];
    },
    loadFormations() {
        const typeEl = document.getElementById('calif-type-select'), el = document.getElementById('calif-formation-select');
        if (!el) return;
        const all = this._formations();
        const types = typeof FormationTypeService !== 'undefined' ? FormationTypeService.getTypes().filter(t => all.some(f => f.type === t.id)) : [];
        if (this._selectedFormationId) {
            const current = all.find(f => String(f.id) === String(this._selectedFormationId));
            if (current && this._selectedType && current.type !== this._selectedType) this._selectedType = current.type;
        }
        if (typeEl) {
            typeEl.hidden = types.length < 2;
            SafeHTML.set(typeEl, '<option value="">Todos los tipos</option>' + types.map(t => `<option value="${Utils.sanitizeHTML(t.id)}">${Utils.sanitizeHTML(t.pluralName || t.name)}</option>`).join(''));
            typeEl.value = this._selectedType;
        }
        const shown = all.filter(f => !this._selectedType || f.type === this._selectedType);
        SafeHTML.set(el, '<option value="">Elige una formación</option>' + shown.map(f => {
            const count = this._studentsOf(f.id).length;
            return `<option value="${Utils.sanitizeHTML(f.id)}">${Utils.sanitizeHTML(f.name || f.commercialName)} · ${count} ${count === 1 ? 'alumno' : 'alumnos'}</option>`;
        }).join(''));
        el.value = this._selectedFormationId && shown.some(f => String(f.id) === String(this._selectedFormationId)) ? this._selectedFormationId : '';
    },
    changeType(value) {
        if (this._saving) return;
        this._confirmLeave(() => {
            this._selectedType = value || '';
            const current = this._formations().find(f => String(f.id) === String(this._selectedFormationId));
            if (current && this._selectedType && current.type !== this._selectedType) this._selectedFormationId = null;
            this.loadFormations();
            this.renderTable();
        });
    },
    async loadCalificaciones() {
        if (!this.canRead()) return;
        const request = ++this._request, epoch = AuthManager._epoch;
        const container = document.getElementById('calif-table-container');
        const current = () => request === this._request && epoch === AuthManager._epoch && container === document.getElementById('calif-table-container');
        this._loading = true; this._ready = false; this._loadError = false;
        this.renderTable();
        try {
            const token = AuthManager.getCsrfToken();
            const res = await fetch('/api/calificaciones', { headers: { 'X-SICAF-CSRF': token } });
            const data = await res.json();
            if (!current()) return;
            if (!res.ok || !data.success || !Array.isArray(data.calificaciones)) throw new Error('No se pudieron cargar las actas.');
            this._calificaciones = data.calificaciones;
            this._ready = true;
            this.loadYears();
        } catch(e) {
            if (!current()) return;
            this._calificaciones = []; this._loadError = true;
        } finally {
            if (current()) { this._loading = false; this.renderTable(); }
        }
    },

    changeFormation(val) {
        if (this._saving) return;
        this._confirmLeave(() => { this._selectedFormationId = val || null; this.loadFormations(); this.renderTable(); });
    },
    changePeriod(val) {
        if (this._saving || !this.PERIODS.some(([id]) => id === val)) return;
        this._confirmLeave(() => { this._selectedPeriod = val; this.renderPeriods(); this.renderTable(); });
    },
    renderTable() {
        const container = document.getElementById('calif-table-container');
        if (!container) return;
        this._dirty = false;
        if (!this._ready) {
            SafeHTML.set(container, this._loadError ? `<div role="alert" class="calif-empty"><p>No se pudieron cargar las actas. No se permite publicar hasta verificar los datos.</p><button type="button" class="calif-retry" ${UIEvents.attr("click", function(event,captured){CalificacionesAdminView.loadCalificaciones();}, [])}>Reintentar</button></div>` : '<div class="calif-empty"><p>Cargando actas…</p></div>');
            this.updateControls();
            return;
        }
        if (!this._selectedFormationId) {
            SafeHTML.set(container, this.renderEmptyState('fa-graduation-cap', 'Elige una formación', 'Elige una formación en el filtro de arriba para ver o poner sus notas.'));
            this.updateControls();
            return;
        }
        const students = this._studentsOf(this._selectedFormationId);
        if (students.length === 0) {
            SafeHTML.set(container, this.renderEmptyState('fa-users-slash', 'Sin alumnos', 'Esta formación no tiene alumnos matriculados.'));
            this.updateControls();
            return;
        }
        const acta = this._acta();
        const notasMap = {};
        (acta?.notas || []).forEach(n => { notasMap[n.studentId] = n; });
        const formation = (DataManager.getFormations ? DataManager.getFormations() : []).find(f => String(f.id) === String(this._selectedFormationId));
        const periodLabel = (this.PERIODS.find(([id]) => id === this._selectedPeriod) || ['', ''])[1];
        const cell = (studentId, name, field, label, value) => `<button type="button" class="calif-cell ${field === 'calificacion' ? 'is-final' : ''}" data-sid="${Utils.sanitizeHTML(studentId)}" data-field="${field}" data-value="${Utils.sanitizeHTML(value || '')}"
            aria-label="${Utils.sanitizeHTML(`${name}, ${label}: ${this._scoreLabel(value)}`)}" ${UIEvents.attr("click", function(event,captured){CalificacionesAdminView.cycleCell(this);}, [])}>${this._scoreLabel(value)}</button>`;
        SafeHTML.set(container, `
            <div class="calif-card-head">
                <div><h2>${Utils.sanitizeHTML(formation ? (formation.name || formation.commercialName) : 'Formación')} · ${periodLabel}</h2>
                    <p>${this.canManage() ? 'Pulsa una casilla para cambiarla: – → Apto → Aviso → No apto.' : 'Solo consulta.'}</p></div>
                <span class="calif-totals" id="calif-totals"></span>
            </div>
            <div class="calif-table-wrap">
                <table class="calif-table">
                    <thead><tr>
                        <th scope="col">Alumno</th>
                        ${this.CRITERIA.map(([, label]) => `<th scope="col">${label}</th>`).join('')}
                        <th scope="col" class="is-final">Calificación</th>
                        <th scope="col">Observaciones</th>
                    </tr></thead>
                    <tbody>
                        ${students.map(student => {
                            const nota = notasMap[student.id] || {};
                            const name = `${student.firstName || ''} ${student.lastName || ''}`.trim();
                            return `<tr>
                                <th scope="row">${Utils.sanitizeHTML(name)}</th>
                                ${this.CRITERIA.map(([field, label]) => `<td>${cell(student.id, name, field, label, nota[field])}</td>`).join('')}
                                <td>${cell(student.id, name, 'calificacion', 'Calificación', nota.calificacion)}</td>
                                <td style="padding-right: 1rem;"><input type="text" class="calif-notes-input" data-sid="${Utils.sanitizeHTML(student.id)}" data-field="tutorias" value="${Utils.sanitizeHTML(nota.tutorias || '')}" placeholder="Ej.: tutoría recomendada" aria-label="Observaciones de ${Utils.sanitizeHTML(name)}"
                                    ${UIEvents.attr("input", function(event,captured){CalificacionesAdminView.markDirty();}, [])}></td>
                            </tr>`;
                        }).join('')}
                    </tbody>
                </table>
            </div>`);
        container.querySelectorAll('.calif-cell').forEach(el => this.updateCellColor(el));
        this.renderTotals();
        this.updateControls();
    },
    _scoreLabel(value) {
        return { APTO: 'Apto', AVISO: 'Aviso', 'NO APTO': 'No apto' }[value] || '–';
    },
    renderTotals() {
        const el = document.getElementById('calif-totals');
        if (!el) return;
        const finals = [...document.querySelectorAll('#calif-table-container .calif-cell[data-field="calificacion"]')].map(c => c.dataset.value || '');
        const n = v => finals.filter(x => x === v).length;
        SafeHTML.set(el, `<span style="background: var(--dnr-teal-100); color: var(--dnr-teal-700);">Aptos ${n('APTO')}</span><span style="background: var(--dnr-amber-100); color: #6B3A0B;">Aviso ${n('AVISO')}</span><span style="background: #FBE4E1; color: #8E2A21;">No apto ${n('NO APTO')}</span><span style="background: var(--dnr-surface-sunken); color: var(--dnr-ink-mute);">Sin nota ${n('')}</span>`);
    },
    markDirty() {
        if (!this.canManage()) return;
        this._dirty = true;
        this.renderStatus();
    },
    cycleCell(el) {
        if (!this.canManage() || this._saving) return;
        const next = this.SCORES[(this.SCORES.indexOf(el.dataset.value || '') + 1) % this.SCORES.length];
        el.dataset.value = next;
        el.textContent = this._scoreLabel(next);
        el.setAttribute('aria-label', (el.getAttribute('aria-label') || '').replace(/:[^:]*$/, `: ${this._scoreLabel(next)}`));
        this.updateCellColor(el);
        this.renderTotals();
        this.markDirty();
    },
    getBgColorForScore(score) {
        if (score === 'APTO') return '#dcfce7'; // green-100
        if (score === 'AVISO') return '#fef3c7'; // amber-100
        if (score === 'NO APTO') return '#fee2e2'; // red-100
        return '#f1f5f9'; // slate-100 (neutro)
    },

    getTextColorForScore(score) {
        if (score === 'APTO') return '#15803d'; // green-700
        if (score === 'AVISO') return '#b45309'; // amber-700
        if (score === 'NO APTO') return '#b91c1c'; // red-700
        return '#64748b'; // slate-500 (neutro)
    },

    updateCellColor(el) {
        const val = el.dataset.value !== undefined ? el.dataset.value : el.value;
        el.style.background = this.getBgColorForScore(val);
        el.style.color = this.getTextColorForScore(val);
        el.style.border = `${el.dataset.field === 'calificacion' ? 2 : 1}px solid ${val ? this.getTextColorForScore(val) : 'var(--dnr-line)'}`;
    },

    async saveCalificaciones() {
        if (!this.canManage() || !this._ready || this._saving || !this._selectedFormationId) return;

        const container = document.getElementById('calif-table-container');
        if (!container) return;
        const rows = container.querySelectorAll('tbody tr');
        if (!rows.length) return;
        const notas = [];
        rows.forEach(row => {
            const input = row.querySelector('input[type="text"]');
            const noteObj = { studentId: input.dataset.sid, studentName: row.querySelector('th').textContent.trim(), tutorias: input.value.trim() };
            row.querySelectorAll('.calif-cell').forEach(cell => { noteObj[cell.dataset.field] = cell.dataset.value || ''; });
            notas.push(noteObj);
        });
        const formations = (typeof DataManager !== 'undefined' && DataManager.getFormations) ? DataManager.getFormations() : [];
        const currentFormation = formations.find(f => String(f.id) === String(this._selectedFormationId));
        const formationName = currentFormation ? currentFormation.name : 'Curso';

        const epoch = AuthManager._epoch;
        const current = () => epoch === AuthManager._epoch && document.getElementById('calif-table-container') === container;
        this._saving = true;
        this.updateControls();
        try {
            SafeHTML.fire({ title: 'Guardando calificaciones...', html: '<i class="fas fa-spinner fa-spin" style="font-size:2rem;color:#2563eb;"></i>', showConfirmButton: false, allowOutsideClick: false });
            
            const token = AuthManager.getCsrfToken();
            const res = await fetch('/api/calificaciones', {
                method: 'POST',
                headers: {
                    'X-SICAF-CSRF': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    formationId: this._selectedFormationId,
                    formationName,
                    period: this._selectedPeriod,
                    year: this._selectedYear,
                    notas
                })
            });

            const data = await res.json();
            if (!current()) return;
            if (!res.ok || !data.success) throw new Error(data.error || 'No se pudo publicar el acta.');

            this._dirty = false;
            SafeHTML.fire({ icon: 'success', title: 'Acta publicada', text: 'El alumnado ya puede ver estas notas.', timer: 2000, showConfirmButton: false });
            
            // Reload local cache
            await this.loadCalificaciones();
            this.renderTable();
        } catch(e) {
            if (current()) SafeHTML.fire('Error', e.message, 'error');
        } finally { this._saving = false; this.updateControls(); }
    }
};

window.CalificacionesAdminView = CalificacionesAdminView;
